import { useMemo } from 'react';

import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core/hooks';
import useBanksListQuery from '@/modules/employer/components/SetupEmployer/FinancialDetails/BankInformation/BanksList/useBanksList.query';
import getIdsFromPath from '@/utils/modifiers/getIdsFromPath';

const useBanksList = () => {
  const { observingOrganization, observingEmployer } = useCurrentOrganization();
  const isSubsidiary = useMemo(() => observingOrganization?.type === OrganizationTypes.subsidiary, [observingOrganization]);
  const { employerId } = getIdsFromPath(observingOrganization.path);

  const { options } = useBanksListQuery(isSubsidiary
    ? observingEmployer?.id || employerId || ''
    : observingOrganization?.id || ''
  );
  return options;
};

export default useBanksList;
